<div class="container d-none d-sm-block" style="width: 100%; align-items: center; text-align: center;">
    <br>

    <header>
        <img src="assets/images/logo-almamedis.png" alt="almaMedis logo" style="height: 83px;">
        <p *ngIf="pagina >= 2" class="letra-sub">En almaMedis podrás</p>
        <p *ngIf="pagina < 2" class="letra-sub">¡Bienvenido!</p>
        <p class="letra-tit">{{titulo[pagina]}}</p>

    </header>
    <main class="body">

        <!-- Paso 1 - Formulario de registro -->
        <div *ngIf="pagina === 0" style="padding: 0 0 20%;">
            <div class="container-fluid m-0 p-0 ">
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <!-- <div class="row" style="margin: 0">
                        <div class="col">
                            <p class="letra-sub">¡Bienvenido!</p>
                            <p class="letra-tit">{{titulo[pagina]}}</p>
    
                        </div>
                    </div> -->
                    <div class="row" >
                        <!-- Columna Izquierda -->
                        <div class="col-6">

                            <div class="form-group">
                                <label for="rut"></label>
                                <input class="form-control" type="text" id="rut" formControlName="rut"
                                    placeholder="Ingresa tu rut" disabled>
                            </div>
                            <div class="error-message">
                            </div>

                            <div class="form-group">
                                <label for="nombre"></label>
                                <input class="form-control" type="text" id="nombre" formControlName="nombre"
                                    placeholder="Ingresa tu nombre">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('nombre')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un nombre valido.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="apellido_paterno"></label>
                                <input class="form-control" type="text" id="apellido_paterno"
                                    formControlName="apellido_paterno" placeholder="Ingresa tu primer apellido">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('apellido_paterno')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un primer apellido valido.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="apellido_materno"></label>
                                <input class="form-control" type="text" id="apellido_materno"
                                    formControlName="apellido_materno" placeholder="Ingresa tu segundo apellido">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('apellido_materno')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un segundo apellido valido.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="genero"></label>
                                <select class="form-control" id="genero" formControlName="genero">
                                    <option value="" disabled selected>Selecciona tu género</option>
                                    <option *ngFor="let genero of generos" [value]="genero">{{ genero }}</option>
                                </select>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('genero')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Selecciona un género.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="fecha_nacimiento_chile"></label>
                                <input
                                  id="fecha_nacimiento_chile"
                                  class="form-control"
                                  type="date"
                                  formControlName="fecha_nacimiento_chile"
                                />
                            </div>
                            <div class="error-message">
                                <!-- Mensaje si el campo está vacío o tiene otro error genérico -->
                                <p
                                  *ngIf="campoNoValido('fecha_nacimiento_chile') && !registerForm.get('fecha_nacimiento_chile')?.hasError('añoInvalido')"
                                  class="text-danger mb-0 pb-0 mt-1"
                                  style="display: flex; align-items: center;"
                                >
                                  <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                  Ingresa tu fecha de nacimiento.
                                </p>
                              
                                <!-- Mensaje si el año es inválido -->
                                <p
                                  *ngIf="registerForm.get('fecha_nacimiento_chile')?.hasError('añoInvalido') && (registerForm.get('fecha_nacimiento_chile')?.touched || formSubmitted)"
                                  class="text-danger mb-0 pb-0 mt-1"
                                  style="display: flex; align-items: center;"
                                >
                                  <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                  La fecha ingresada no puede ser mayor a la fecha actual.
                                </p>
                            </div> 
                        </div>

                        <!-- Columna Derecha -->
                        <div class="col-6">

                            <div class="form-group">
                                <label for="email"></label>
                                <input class="form-control" type="text" id="email" formControlName="email"
                                    placeholder="Ingresa tu email">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('email')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un email valido.
                                </p>
                            </div>


                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-btn">
                                        <button type="button" class="btn btn-secondary dropdown-toggle"
                                            (click)="toggleDropdown()" aria-haspopup="true" aria-expanded="false"
                                            style="display: flex; align-items: center; min-height: 38px;">
                                            <span [class]="'fi ' + selectedAreaCode.cou_flag"
                                                style="margin: 0 5px;"></span>
                                            <p style="margin: 0 !important;"> (+{{ selectedAreaCode.cou_phone_code }})
                                            </p>
                                            <!-- <mat-icon>expand_more</mat-icon> -->
                                        </button>
                                        <div class="dropdown-menu" [ngClass]="{'show': dropdownOpen}"
                                            (clickOutside)="closeDropdown()">
                                            <button class="dropdown-item" *ngFor="let areaCode of areaCodes"
                                                (click)="selectAreaCode(areaCode); $event.preventDefault()">
                                                <span [class]="'fi ' + areaCode.cou_flag"></span> (+{{
                                                areaCode.cou_phone_code }})
                                            </button>
                                        </div>

                                    </div>
                                    <input class="form-control" type="tel" formControlName="telefono" id="telefono"
                                        placeholder="Teléfono">
                                </div>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('telefono')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa entre {{selectedAreaCode?.cou_min_phone}} y
                                    {{selectedAreaCode?.cou_max_phone}} dígitos
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="pais"></label>
                                <select class="form-control" id="pais" formControlName="pais">
                                    <option value="" disabled selected>Selecciona tu País</option>
                                    <option *ngFor="let pais of paises" [value]="pais.cou_id">{{ pais.cou_name }}
                                </select>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('pais')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Selecciona un País.
                                </p>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="region"></label>
                                        <select class="form-control" id="region" formControlName="region">
                                            <option value="" disabled selected>Selecciona tu región</option>
                                            <option *ngFor="let region of regiones" [value]="region.reg_id">{{
                                                region.reg_name}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="error-message">
                                        <p *ngIf="campoNoValido('region')" class="text-danger mb-0 pb-0 mt-1"
                                            style="display: flex; align-items: center;">
                                            <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                            Selecciona un Región.
                                        </p>
                                    </div>

                                </div>
                                <div class="col-6">

                                    <div class="form-group">
                                        <label for="comuna"></label>
                                        <select class="form-control" id="comuna" formControlName="comuna">
                                            <option value="" disabled selected>Selecciona tu comuna</option>
                                            <option *ngFor="let comuna of comunas" [value]="comuna.com_id">{{
                                                comuna.com_name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="error-message">
                                        <p *ngIf="campoNoValido('comuna')" class="text-danger mb-0 pb-0 mt-1"
                                            style="display: flex; align-items: center;">
                                            <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                            Selecciona una comuna.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="direccion"></label>
                                <input class="form-control" type="text" id="direccion" formControlName="direccion"
                                    placeholder="Ingresa tu dirección">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('direccion')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa una dirección.
                                </p>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                      <label for="numero"></label>
                                      <input
                                        class="form-control"
                                        type="text"
                                        id="numero"
                                        formControlName="numero"
                                        placeholder="Ingresa tu numeración"
                                      />
                                    </div>
                                    <div class="error-message">
                                      <p *ngIf="campoNoValido('numero')" class="text-danger mb-0 pb-0 mt-1" style="display: flex; align-items: center;">
                                        <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                        Ingresa una numeración válida.
                                      </p>
                                    </div>
                                  </div>
                                  
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="rest"></label>
                                        <input class="form-control" type="text" id="rest" formControlName="rest"
                                            placeholder="Departamento / Oficina">
                                    </div>
                                    <!-- <p *ngIf="campoNoValido('rest')" class="text-danger mb-0 pb-0 mt-1" style="display: flex; align-items: center;">
                                        <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                        Ingresa una numeración.
                                    </p> -->

                                </div>
                            </div>

                        </div>
                        <!--
                        <div class="form-check planes col-6 d-flex align-items-center pl-0 ps-0">
                            <input mdbCheckbox class="form-check-input mr-2 me-2" type="checkbox" formControlName="acceptTerms" id="flexCheckTerms" />
                            <label class="form-check-label mb-0" for="flexCheckTerms">
                                Acepto términos y condiciones.
                            </label>
                            <b class="terminos-condiciones ml-1 ms-1" data-toggle="modal" data-target="#modalTerms">
                                <span class="verMas">(Ver más).</span>
                            </b>
                        </div>
                        -->
                    </div>
                </form>
            </div>
        </div>

        <div *ngIf="pagina === 1" style="padding: 0 10% 20%;">
            <div class="container-fluid m-0 p-0 ">
                <form [formGroup]="cambiaPass" (ngSubmit)="cambiaPassword()">
                    <!-- <div class="row">
                            <div class="col">
                                <p class="letra-tit" style="margin: 50px 0 20px;">{{titulo[pagina]}}</p>
        
                            </div>
                        </div> -->
                    <div class="row cambia-pass" style="padding: 0 20%;">
                        <div class="col">

                            <div class="form-group row signup-input-wrapper signup-input-wrapper-addon"
                                [ngClass]="{'signup-input-wrapper-addon-blue': signupPass, 'signup-input-wrapper-addon-gray': !signupPass}" style="display: flex;
                                flex-wrap: nowrap;
                                padding-right: 5px;">
                                <div class="col-10 col-md-11 m-0 signup-custom-input">
                                    <div class="input-group m-0 p-0">
                                        <input class="form-control" [type]="fieldTextType1 ? 'text' : 'password'"
                                            formControlName="contrasena_actual" id="contrasena_actual"
                                            name="contrasena_actual" placeholder="Contraseña actual"
                                            onfocus="this.placeholder = '';"
                                            onblur="this.placeholder = 'Contraseña actual';" (focus)="signupPass=true;"
                                            (blur)="signupPass=false;" (input)="checkPass1()">
                                    </div>
                                </div>
                                <div class="col-2 col-md-1 m-0 m-0 align-self-center"
                                    style="display: flex; justify-content: center;">
                                    <span class="calendar" (click)="toggleFieldTextType1()">
                                        <mat-icon>{{ fieldTextType1 ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </span>
                                </div>
                            </div>
                            <br>
                            <div class="form-group row signup-input-wrapper signup-input-wrapper-addon"
                                [ngClass]="{'signup-input-wrapper-addon-blue': signupPass1Focus, 'signup-input-wrapper-addon-gray': !signupPass1Focus}" style="display: flex;
                                flex-wrap: nowrap;
                                padding-right: 5px;;">
                                <div class="col-10 col-md-11 m-0 signup-custom-input">
                                    <div class="input-group m-0 p-0">
                                        <input class="form-control" [type]="fieldTextType2 ? 'text' : 'password'"
                                            formControlName="contrasena_nueva" id="contrasena_nueva"
                                            name="contrasena_nueva" placeholder="Contraseña nueva*"
                                            onfocus="this.placeholder = '';"
                                            onblur="this.placeholder = 'Contraseña nueva*';"
                                            (focus)="signupPass1Focus=true;" (blur)="signupPass1Focus=false;"
                                            (input)="checkPass1()">
                                    </div>
                                </div>
                                <div class="col-2 col-md-1 m-0 m-0 align-self-center"
                                    style="display: flex; justify-content: center;">
                                    <span class="calendar" (click)="toggleFieldTextType2()">
                                        <mat-icon>{{ fieldTextType2 ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </span>
                                </div>
                            </div>
                            <br>
                            <div class="password-desc ">
                                <p class="{{ passLength === 0 && !formSubmitted2 ? 
                                        'default' : 
                                        passMinLength ? 
                                        'ok' : 
                                        'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">{{ passLength === 0 && !formSubmitted2 ?
                                        'radio_button_unchecked' : passMinLength ? 'check_circle' : 'cancel'
                                        }}</mat-icon>
                                    Debe contener al menos 8 caracteres
                                </p>
                                <p class="{{ passLength === 0 && !formSubmitted2 ?
                                        'default' :
                                        passCapital ?
                                        'ok' :
                                        'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">{{ passLength === 0 && !formSubmitted2 ?
                                        'radio_button_unchecked' : passCapital ? 'check_circle' : 'cancel' }}</mat-icon>

                                    Debe contener al menos 1 mayúscula
                                </p>
                                <p class="{{ passLength === 0 && !formSubmitted2 ?
                                        'default' :
                                        passLetter ?
                                        'ok' :
                                        'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">{{ passLength === 0 && !formSubmitted2 ?
                                        'radio_button_unchecked' : passLetter ? 'check_circle' : 'cancel' }}</mat-icon>
                                    Debe contener al menos 1 minúscula
                                </p>
                                <p class="{{ passLength === 0 && !formSubmitted2 ?
                                        'default' :
                                        passNumber ?
                                        'ok' :
                                        'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">{{ passLength === 0 && !formSubmitted2 ?
                                        'radio_button_unchecked' : passNumber ? 'check_circle' : 'cancel' }}</mat-icon>
                                    Debe contener al menos 1 numero
                                </p>
                            </div>
                            <br>
                            <div class="form-group row signup-input-wrapper signup-input-wrapper-addon"
                                [ngClass]="{'signup-input-wrapper-addon-blue': signupPass2Focus, 'signup-input-wrapper-addon-gray': !signupPass1Focus}" style="display: flex;
                                flex-wrap: nowrap;
                                padding-right: 5px;">
                                <div class="col-10 col-md-11 m-0 signup-custom-input">
                                    <div class="input-group m-0 p-0">
                                        <input class="form-control" [type]="fieldTextType3 ? 'text' : 'password'"
                                            formControlName="contrasena_nueva_2" id="contrasena_nueva_2"
                                            name="contrasena_nueva_2" placeholder="Contraseña nueva*"
                                            onfocus="this.placeholder = '';"
                                            onblur="this.placeholder = 'Repetir contraseña nueva*';"
                                            (focus)="signupPass2Focus=true;" (blur)="signupPass2Focus=false;"
                                            (input)="checkPass1()">
                                    </div>
                                </div>
                                <div class="col-2 col-md-1 m-0 m-0 align-self-center"
                                    style="display: flex; justify-content: center;">
                                    <span class="calendar" (click)="toggleFieldTextType3()">
                                        <mat-icon>{{ fieldTextType3 ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </span>
                                </div>
                            </div>
                            <br>

                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Páginas con imágenes -->
        <div *ngIf="pagina === 2">
            <img src="assets/images/onboarding/paciente/desktop/pant0.png" style="height: 45vh;">
        </div>
        <div *ngIf="pagina === 3">
            <img src="assets/images/onboarding/paciente/desktop/pant1.png" style="height: 45vh;">
        </div>
        <div *ngIf="pagina === 4">
            <img src="assets/images/onboarding/paciente/desktop/pant2.png" style="height: 45vh;">
        </div>
        <div *ngIf="pagina === 5">
            <img src="assets/images/onboarding/paciente/desktop/pant3.png" style="height: 45vh;">
        </div>
        <div *ngIf="pagina === 6">
            <img src="assets/images/onboarding/paciente/desktop/pant4.png" style="height: 45vh;">
        </div>

        <!--
        <div class="modal fade" id="modalTerms"  role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-body ">
                        <div class="modal-content-scroll">
                            <h5 id="exampleModalLongTitle">TÉRMINOS Y CONDICIONES DE USO DE PLATAFORMA DE TELEMEDICINA ALMAMEDIS.<br>
                                NO UTILICE ESTE SITIO WEB EN CASO DE UNA EMERGENCIA O URGENCIA MEDICAS<br>
                                SI TIENE UNA EMERGENCIA O URGENCIA DE SALUD DIRIJASE DE INMEDIATO A UN CENTRO DE ATENCIÓN HOSPITALARIA O
                                CLINICA.
                            </h5>
                            <br>
                            <div class="terminos-condiciones">
                                <h4>BIENVENIDO</h4>
                                <br>
                                Usted está accediendo a esta plataforma para poder hacer uso del servicio de asistencia de telemedicina.
                                Para estos efectos usted ha contratado los servicios de la asistencia de telemedicina con Almamedis, quien
                                ha dispuesto los Términos y Condiciones para el uso de este sitio web, así como de los servicios y las
                                herramientas provistas a través de éste, lo que está condicionado a la aceptación por parte de usted de los
                                términos de uso descritos a continuación.
                                El acceso y uso de este sitio web se rige por los Términos y Condiciones descritos a continuación, así como
                                por la legislación que se aplique en la República de Chile a los mismos. En consecuencia, todas las visitas
                                y todos los servicios que se realicen en este sitio, como asimismo sus efectos jurídicos, quedarán regidos
                                por estas condiciones o reglamento y sometidas a esa legislación.
                                Este documento describe los términos, condiciones generales y las condiciones particulares, en adelante
                                ("Términos y Condiciones” aplicables al uso de los servicios ofrecidos y/o provistos por Almamedis), dentro
                                del sitio web https://telemedicina.almamedis.cl, incluidas las herramientas provistas a través del mismo
                                para la realización de video-consultas a distancia e intercambio de información y/o datos personales, en
                                adelante también referidos como “Servicios”.
                                Cualquier persona que desee usar el Sitio o los Servicios podrá hacerlo previa aceptación de los Términos y
                                Condiciones acá descritos.
                                <br>
                                <br>
                                <h4>CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO
                                Y
                                VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR EL SITIO Y/O LOS SERVICIOS ASOCIADOS AL MISMO.</h4>
                                <br>
                                Usted debe leer, entender y aceptar todas las condiciones establecidas en los Términos y Condiciones, previo
                                a su inscripción como Usuario de Almamedis.
                                Debe entender que las interacciones con los proveedores de servicios de consulta médica a través de
                                Almamedis son un complemento de la relación personal que pueda tener con un profesional de la salud. Por
                                consiguiente, los servicios ofrecidos por Almamedis no están necesariamente destinados a sustituir los
                                exámenes físicos o controles regulares de salud que puede realizar o le aconseje un profesional de salud.
                                <br>
                                <br>
                                <h4>INDEPENDENCIA DE CRITERIO PROFESIONAL</h4>
                                <br>
                                Usted entiende y acepta que Almamedis presta sus servicios vía plataforma web, para atenciones de salud, las
                                que son efectuadas bajo el conocimiento y criterio del profesional respectivo.
                                Todos los profesionales de la salud que se encuentran disponibles para consultas “on-line”, ofrecen sus
                                servicios en el libre ejercicio de su profesión y utilizan Almamedis como un medio para comunicarse con
                                Usted o su beneficiario.
                                Cualquier información, recomendación, indicación o diagnóstico recibido de un “Profesional de la salud” a
                                través de Almamedis, proviene exclusivamente de aquel, no pudiendo Almamedis intervenir en el acto
                                profesional mismo, ya sea que se trate de diagnóstico, medicación, tratamiento u otros. Sin perjuicio de
                                ello, Almamedis, es responsable de la elección de los profesionales que acceden a la plataforma y de
                                chequear sus títulos o habilitaciones profesionales, de manera que quienes prestan su servicio mediante la
                                plataforma Almamedis sean profesionales habilitados en Chile para el ejercicio de la profesión médica.
                                <br>
                                <br>
                                <h4>SEGURIDAD Y FUNCIONAMIENTO DE LA PLATAFORMA Y EL SERVICIO</h4>
                                <br>
                                Queda establecido que Almamedis implementará y ejecutará todos los procedimientos y estándares de seguridad
                                de la información que adhieren a la norma ISO27001, de modo de proteger su privacidad y limitar el riesgo de
                                pérdida de información.
                                Usted conoce y acepta que para el adecuado funcionamiento de la plataforma Almamedis debe contar con una
                                conexión a internet de banda ancha estable y un dispositivo electrónico con las características técnicas
                                suficientes para reproducir una videoconferencia. Almamedis no se responsabiliza de una interrupción en el
                                servicio a causa de fallas en la conexión que provengan de la calidad de la banda ancha y/o de los equipos
                                electrónicos de su propiedad.
                                <br>
                                <br>
                                <h4>SELECCIÓN DE PROFESIONALES MÉDICOS DISPONIBLES</h4>
                                <br>
                                Cuando el Paciente o “Usuario” solicita una consulta para obtener la atención de un “Profesional de la
                                salud”, Almamedis le ofrecerá la opción de consultar con cualquier profesional independiente afiliado a
                                nuestra red, que se encuentre disponible para atenderlo. Para su tranquilidad, Almamedis selecciona a
                                profesionales de la salud que cumplen con los requisitos que la legislación vigente en nuestro país para
                                proveer los servicios que ofrecen.
                                Cuando Usted solicita una consulta, está aceptando específicamente que el “Profesional de la salud” que
                                Usted ha seleccionado podrá, desde ese momento, acceder a su historial clínico que se encuentre disponible
                                en la plataforma. Igualmente, al solicitar una consulta, usted está dando inicio a una relación directa
                                “Profesional de la salud” – “Usuario”, a través de la plataforma de telemedicina de Almamedis.
                                <br>
                                <br>
                                <h4>RESPONSABILIDAD</h4>
                                <br>
                                Almamedis es responsable de contar con una red de profesionales de salud idóneos que cumplan con la
                                normativa vigente para ejercer su profesión en Chile.
                                <br>
                                <br>
                                <h4>REGISTRO COMO USUARIO</h4>
                                <br>
                                Para tener acceso a los servicios en línea, deberá registrarse como “Usuario” y deberá crear una cuenta
                                personal, suministrando la información que se solicita. Con la excepción de las cuentas de sus asegurados
                                adicionales cuando corresponda, Usted acuerda no crear más de una cuenta de usuario, ni crear una cuenta
                                para otra persona, si no ha sido autorizado de manera expresa y escrita. Asimismo, Usted se compromete a
                                proveer información correcta, verdadera y actualizada al momento de registrarse o cuando realice la
                                actualización de su ficha de información personal para así permitir una buena gestión en trámites como
                                cambios de contraseña, recepción de comprobantes de venta y confirmación de horas médicas.
                                <br>
                                <br>
                                <h4>SEGURIDAD</h4>
                                <br>
                                Al registrarse, deberá ingresar sus datos y una clave de acceso (la cual podrá modificar regularmente).
                                Estos datos son personales e intransferibles y usted es responsable de mantener la seguridad de su cuenta,
                                cuidando en todo momento la seguridad y confidencialidad de sus claves de acceso. Usted entiende y acepta
                                que en ningún caso podrá facilitar el acceso de terceros a Almamedis mediante el uso de su nombre de usuario
                                y contraseña.
                                <br>
                                <br>
                                <h4>POLÍTICA DE PRIVACIDAD</h4>
                                <br>
                                Almamedis garantiza la confidencialidad “Profesional de la Salud” – “Usuario”. Toda información que
                                relacione su identidad con las condiciones físicas y mentales presentes, pasadas o futuras y su historia de
                                salud, es considerada información de carácter privado y será tratada como tal.
                                Como parte de su proceso operativo, Almamedis registra su información personal y se obliga a no cederla,
                                licenciarla o compartirla fuera de Almamedis ni a sus entidades asociadas. Con la aceptación de estos
                                Términos y Condiciones, usted nos autoriza desde ya en forma expresa a almacenar y emplear dicha información
                                para permitir que Almamedis provea los servicios de telemedicina.
                                El usuario gozará de todos los derechos que le reconoce la Ley Nº19.628 sobre protección de datos y la ley
                                del consumidor en Chile.
                                <br>
                                <br>
                                <h4>COOKIES</h4>
                                <br>
                                Como la mayoría de los sitios web, utilizamos "cookies" y archivos de registro web para analizar el uso del
                                sitio, para mejorar la calidad de nuestro servicio y con la finalidad de personalizar en la medida de lo
                                posible su experiencia en nuestro sitio web. Una cookie es un archivo de datos que reside en su computadora,
                                teléfono inteligente, tableta o cualquier otro dispositivo desde el que ingrese y permite su reconocimiento
                                como usuario cuando regrese a nuestro sitio web desde el mismo equipo, siempre que utilice el mismo
                                navegador.
                                Usted tiene el derecho de eliminar o bloquear las cookies de nuestro sitio web utilizando la configuración
                                de su navegador, pero esto podría afectar su capacidad para ingresar o utilizar nuestros servicios.
                                <br>
                                <br>
                                <h4>POLÍTICAS Y CONDICIONES DE PAGO</h4>
                                <br>
                                Al realizar el pago a través del sistema web de Transbank o cualquier otro método que Almamedis estime
                                conveniente, usted acepta las condiciones que se establecen a continuación, manifestando su total
                                conformidad. Por lo que solicitamos leer con detención los términos y condiciones que rigen el uso de
                                nuestra página web, junto con el alcance de la contratación electrónica del servicio de telemedicina.

                                El valor del servicio de atención de telemedicina deberá ser pagado antes de recibir la atención, pudiendo
                                utilizar las opciones de pago que estarán disponibles en el proceso de agendamiento de la consulta. Las
                                formas de pago podrán ser, pero no se limitarán: Transbank y otras tecnologías de pago virtual.

                                El servicio de telemedicina deberá ser pagado de forma particular en su totalidad o en parte, dependiendo de
                                si se selecciona un plan o convenio. Se podrá gestionar posteriormente el reembolso con la institución de
                                salud previsional que tenga el paciente atendido, sin embargo, Almamedis no se responsabiliza en caso de que
                                el paciente no tenga la cobertura o la institución de salud previsional se niegue a efectuar el reembolso.
                                Si existiera un cobro por uso de un servicio adicional específico, no cubierto en el precio final de la
                                atención, usted será informado, de forma previa y a través del sistema, del cargo correspondiente a aplicar
                                en el momento de acceder al servicio en cuestión.
                                Los servicios ofrecidos en esta plataforma, salvo que se señale un método diferente para casos particulares
                                u ofertas de determinados servicios, sólo podrán ser pagados con los medios disponibles y que se indican en
                                el sistema. Las tarjetas emitidas en el extranjero no admiten la modalidad de pago en cuotas.
                                El uso de las tarjetas se sujetará a lo establecido en estos términos y condiciones y en relación con su
                                emisor a lo pactado en los respectivos contratos de apertura y reglamento de uso. En caso de contradicción,
                                predominará lo expresado en ese último instrumento. A mayor abundamiento, tratándose de tarjetas bancarias o
                                de tarjetas no bancarias aceptadas en este sitio, los aspectos relativos a ésta, tales como la fecha de
                                emisión, caducidad, cupo, bloqueos, etc., se regirán por el respectivo contrato de apertura y reglamento de
                                uso, de tal forma que Almamedis no tendrá responsabilidad en cualquiera de los aspectos señalados. El sitio
                                podrá indicar determinadas condiciones de compra según el medio de pago que se utilice por el usuario.
                                <br>
                                <br>
                                <h4>POLÍTICAS DE CANCELACIÓN, REEMBOLSOS Y NO PRESENTACIÓN</h4>
                                <br>
                                La cancelación o modificación del servicio debe realizarse antes de las 20:00 horas del día anterior a la
                                consulta para que se procese la devolución del cargo de la reserva. Si se realiza con menos tiempo del
                                descrito, Almamedis no podrá realizar modificaciones al servicio ni realizar ningún tipo de devolución por
                                los servicios contratados.
                                En el caso de la cancelación, los servicios que hayan sido reservados utilizando algún plan o convenio en la
                                plataforma, no se descontarán de la cantidad total establecida, solo en los casos que dichas cancelaciones
                                se hayan realizado con al menos 1 hora de anticipación a la hora de la consulta.

                                El profesional de la salud, por protocolo, esperará al paciente hasta 15 minutos posterior a iniciada la
                                hora de la consulta. Si en ese periodo de tiempo el paciente no se conecta, es posible que la atención no se
                                concrete, a menos que exista una coordinación externa entre paciente y profesional de la salud apoyada por
                                la mesa de ayuda. En caso de no presentación del paciente, no existirá devolución del dinero.

                                El paciente deberá esperar un máximo de 10 minutos al profesional de la salud. Si en ese periodo el
                                profesional de la salud no se conecta, la mesa de ayuda llamará al paciente para ofrecer alternativas para
                                un reagendamiento o reembolso.
                                Los reembolsos por citas canceladas se procesarán dentro de los 30 días hábiles posteriores a la
                                cancelación, siempre que la cancelación se haya realizado dentro del plazo estipulado. Los reembolsos se
                                realizarán al método de pago original utilizado para la cita u otro señalado por el paciente en un proceso
                                manual de reembolso.
                                <br>
                                <br>
                                <h4>PRECIOS</h4>
                                <br>
                                El precio de las consultas en la plataforma puede estar sujeto a cambios. Los usuarios podrán visualizar el
                                precio actualizado del servicio al momento de realizar el agendamiento y el pago.
                                <br>
                                <br>
                                <h4>PROPIEDAD INTELECTUAL E INDUSTRIAL – ENLACES</h4>
                                <br>
                                Todos los derechos de propiedad industrial e intelectual de este sitio, así como de los elementos contenidos
                                en el mismo (incluyendo con carácter enunciativo pero no limitativo, marcas, signos distintivos, nombres
                                comerciales, dominios, imágenes, fotografías, sonido, audio, video, diseño gráfico, código fuente, logos,
                                contenidos, textos, gráficos, ilustraciones, bases de datos y demás elementos) son de la propiedad exclusiva
                                de Almamedis, quien se reserva expresamente todos los derechos derivados del mismo.
                                Los contenidos de las pantallas relativas a los servicios de Almamedis, así como también los programas,
                                bases de datos, redes y/o archivos que permitan al usuario acceder y usar su cuenta, son propiedad de
                                Almamedis y están protegidos por las leyes y los tratados internacionales de derecho de autor, marcas,
                                patentes, modelos y diseños industriales.
                                El Sitio puede contener enlaces a otros sitios web, lo cual no indica que sean propiedad u operados por
                                Almamedis. En virtud de que Almamedis no tiene control sobre tales sitios, no será responsable por los
                                contenidos, materiales, acciones y/o servicios prestados por los mismos, ni por eventuales daños o pérdidas
                                ocasionadas por la utilización de éstos, sean causadas directa o indirectamente. La existencia de enlaces a
                                otros sitios web no implica una sociedad, relación, aprobación, respaldo de Almamedis a dichos sitios y/o su
                                contenido.
                                Queda expresamente prohibida la reproducción, distribución o difusión de la totalidad o parte de los
                                contenidos de este sitio con fines comerciales, sin la autorización expresa y escrita de Almamedis. El uso
                                indebido y la reproducción total o parcial de dichos contenidos quedan prohibidos, salvo autorización
                                expresa y por escrito de Almamedis.
                                El Usuario se compromete a respetar los derechos de propiedad Intelectual e Industrial de Almamedis y deberá
                                abstenerse de suprimir, alterar, eludir o manipular cualquier dispositivo de protección o sistema de
                                seguridad que estuviera instalado en este sitio web.
                                <br>
                                <br>
                                <h4>MODIFICACIONES</h4>
                                <br>
                                Almamedis se reserva el derecho de efectuar sin previo aviso las modificaciones y/o mejoras que considere
                                oportunas en este sitio web, o en sus aplicaciones, pudiendo cambiar, suprimir o añadir enlaces, contenidos
                                y servicios que se prestan a través del mismo y/o la forma en que aparezcan presentados.
                                <br>
                                <br>
                                <h4>DERECHO DE EXCLUSIÓN</h4>
                                <br>
                                Almamedis se reserva el derecho de denegar o retirar el acceso a su sitio web y/o servicios ofrecidos a
                                cualquier usuario que incumpla las condiciones estipuladas en estos Términos y Condiciones. El uso indebido
                                o malicioso será notificado al Usuario.
                                <br>
                                <br>
                                <h4>MODIFICACIONES DEL PRESENTE AVISO LEGAL</h4>
                                <br>
                                Almamedis se reserva el derecho a modificar, desarrollar o actualizar en cualquier momento, con previa
                                notificación, los Términos y Condiciones de este sitio web. El Usuario deberá aceptar los Términos y
                                Condiciones que se hallen vigentes en el momento en que acceda y haga uso de los servicios.
                                <br>
                                <br>
                                <h4>DOMICILIO</h4>
                                <br>
                                Se fija como domicilio de Almamedis: Huérfanos #865, of. 1603, comuna y ciudad de Santiago, República de
                                Chile.
                                Si Usted tiene alguna duda sobre los Términos y Condiciones que rigen el Sitio o sobre los Servicios
                                ofrecidos, deberá comunicarse con nuestro equipo de Atención al Cliente (contacto@almamedis.cl) para
                                resolver dicha duda.
                                <br>
                                <br>
                                <h4>NOTIFICACIONES</h4>
                                <br>
                                Almamedis utilizará diferentes medios de comunicación para notificar el resultado de ciertas acciones,
                                procesos o procedimientos realizados por usted o de manera automática a nuestros sistemas. Dentro de estos
                                canales de comunicación se encuentran los canales telefónicos, correo electrónico, mensajes de texto,
                                mensajes instantáneos por la aplicación de mensajería WhatsApp, notificaciones de escritorio en los
                                navegadores y notificaciones push provenientes de nuestra aplicación. Por la aceptación de los Términos y
                                Condiciones, usted acepta recibir estas notificaciones en la línea telefónica, aplicaciones y cuentas que
                                registre como propias en nuestra aplicación.
                                <br>
                                <br>
                                <h4>ACEPTACIÓN Y AUTORIZACIÓN</h4>
                                <br>
                                Usted manifiesta que ha leído con detenimiento este documento, se obliga a cumplir con lo aquí estipulado,
                                acepta expresamente todas las disposiciones en él contenidas y cumple con otorgar la autorización
                                correspondiente en favor de Almamedis por el uso de esta plataforma y en beneficio de los Profesionales de
                                la Salud, para los procedimientos y/o consultas que obtenga a través de la misma.
                                El Usuario entiende que la aceptación de los Términos y Condiciones aquí contenidos, es equivalente a un
                                contrato escrito y con este protocolo se da cumplimiento expreso a la legislación nacional vigente.
                                <br>
                                <br>
                                <br>
                                <br>
                            </div>
                        </div>
                    </div>
                    <div class="footer-modal">
                        <button type="button" class="btn btn-aplicar" data-dismiss="modal" style="padding: 0 !important;">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        -->

    </main>



    <footer class="footer">

        <!-- Navegación entre páginas -->
        <div>
            <!-- <mat-icon *ngIf="pagina == 0" class="boton-circulo" [ngStyle]="{color: estilo[0]}">circle</mat-icon>
            <mat-icon *ngIf="pagina == 1" class="boton-circulo" [ngStyle]="{color: estilo[1]}">circle</mat-icon> -->
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[2]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[3]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[4]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[5]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[6]}">circle</mat-icon>
        </div>

        <!-- Subtítulos de las páginas -->
        <p class="letra-subtit">{{subtitulo[pagina]}}</p>

        <!-- Botones de navegación -->
        <div class="d-flex align-items-center justify-content-center">
            <div *ngIf="pagina < 6" style="width: 100%;
            height: 60px;
            text-align: center;
            display: flex;
            justify-content: space-around;
            align-items: center;">
                <button *ngIf="pagina < 2" (click)="salirBoton()" class="boton-omitir">Salir</button>
                <button *ngIf="pagina > 2" (click)="volverBoton()" class="boton-omitir">Volver</button>
                <button *ngIf="pagina == 2" (click)="omitirBoton()" class="boton-omitir">Omitir</button>
                <button *ngIf="pagina >= 2" (click)="siguienteBoton()" class="boton-siguiente" style="float: right;">Siguiente</button>
                <button 
                *ngIf="pagina == 0" 
                    class="boton-siguiente" 
                    [ngClass]="{'boton-siguiente-disabled': registerForm.invalid}" 
                    [disabled]="registerForm.invalid" 
                    (click)="siguienteBoton()" 
                    style="float: right;">
                    Siguiente
                </button>
                <button 
                *ngIf="pagina == 1" 
                    class="boton-siguiente" 
                    [ngClass]="{'boton-siguiente-disabled': cambiaPass.invalid}" 
                    [disabled]="cambiaPass.invalid" 
                    (click)="siguienteBoton()" 
                    style="float: right;">
                    Siguiente
                </button>
            </div>
            <div *ngIf="pagina > 5" style="width: 55%; height: 60px; align-items: center; text-align: center;">
                <button (click)="empezemosBoton()" class="boton-siguiente">¡Empecemos!</button>
            </div>
        </div>
        
    </footer>
</div>



<div class="container d-sm-none" style="width: 100%; align-items: center;text-align: center;     height: 100%;">
    <br>
    <header>
        <img src="assets/images/logo-almamedis.png" alt="alamedis logo" style="width:70%;">
        <p *ngIf="pagina>=2" class="letra-sub" style="font-size: 28px;">En AlmaMedis podrás</p>
        <p class="letra-tit" style="font-size: 24px;">{{titulo2[pagina]}}</p>
        <p *ngIf="pagina<2" class="letra-sub" style="font-size: 24px;">{{titulo[pagina]}}</p>

    </header>
    <main class="body" style="width: 100%;">
        <div>

            <img *ngIf="pagina==2" src="assets/images/onboarding/paciente/mobile/pantallazo0.png"
                style="height: 70vh; margin-bottom: -33%;">
            <img *ngIf="pagina==3" src="assets/images/onboarding/paciente/mobile/pantallazo1.png"
                style="height: 70vh; margin-bottom: -33%;">
            <img *ngIf="pagina>3" src="assets/images/onboarding/paciente/mobile/pantallazo2.png"
                style="height: 70vh; margin-bottom: -33%;">
        </div>

        <div *ngIf="pagina === 0" style="padding: 0 0 40%;">
            <div class="container-fluid m-0 p-0 ">

                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <!-- <div class="row" style="margin: 0">
                        <div class="col">
                            <p class="letra-sub">¡Bienvenido!</p>
                            <p class="letra-tit">{{titulo[pagina]}}</p>
    
                        </div>
                    </div> -->
                    <div class="row" style="padding: 0 5%;">
                        <!-- Columna Izquierda -->
                        <div class="col-12">

                            <div class="form-group">
                                <label for="rut"></label>
                                <input class="form-control" type="text" id="rut" formControlName="rut"
                                    placeholder="Ingresa tu rut" disabled>
                            </div>
                            <div class="error-message">
                            </div>

                            <div class="form-group">
                                <label for="nombre"></label>
                                <input class="form-control" type="text" id="nombre" formControlName="nombre"
                                    placeholder="Ingresa tu nombre">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('nombre')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un nombre valido.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="apellido_paterno"></label>
                                <input class="form-control" type="text" id="apellido_paterno"
                                    formControlName="apellido_paterno" placeholder="Ingresa tu primer apellido">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('apellido_paterno')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un primer apellido valido.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="apellido_materno"></label>
                                <input class="form-control" type="text" id="apellido_materno"
                                    formControlName="apellido_materno" placeholder="Ingresa tu segundo apellido">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('apellido_materno')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un segundo apellido valido.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="genero"></label>
                                <select class="form-control" id="genero" formControlName="genero">
                                    <option value="" disabled selected>Selecciona tu género</option>
                                    <option value="masculino">Masculino</option>
                                    <option value="femenino">Femenino</option>
                                    <option value="otro">Otro</option>
                                </select>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('genero')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Selecciona un género.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="fecha_nacimiento_chile"></label>
                                <input
                                  id="fecha_nacimiento_chile"
                                  class="form-control"
                                  type="date"
                                  formControlName="fecha_nacimiento_chile"
                                />
                              </div>
                              <div class="error-message">
                                <!-- Mensaje genérico (campo requerido) -->
                                <p
                                  *ngIf="campoNoValido('fecha_nacimiento_chile') && !registerForm.get('fecha_nacimiento_chile')?.hasError('añoInvalido')"
                                  class="text-danger mb-0 pb-0 mt-1"
                                  style="display: flex; align-items: center;"
                                >
                                  <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                  Ingresa tu fecha de nacimiento.
                                </p>
                              
                                <!-- Mensaje específico (año mayor al actual) -->
                                <p
                                  *ngIf="registerForm.get('fecha_nacimiento_chile')?.hasError('añoInvalido') && (registerForm.get('fecha_nacimiento_chile')?.touched || formSubmitted)"
                                  class="text-danger mb-0 pb-0 mt-1"
                                  style="display: flex; align-items: center;"
                                >
                                  <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                  La fecha ingresada no puede ser mayor a la fecha actual.
                                </p>
                              </div>
                              



                            <!-- Columna Derecha -->

                            <div class="form-group">
                                <label for="email"></label>
                                <input class="form-control" type="text" id="email" formControlName="email"
                                    placeholder="Ingresa tu email">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('email')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa un email valido.
                                </p>
                            </div>


                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-btn">
                                        <button type="button" class="btn btn-secondary dropdown-toggle"
                                            (click)="toggleDropdown()" aria-haspopup="true" aria-expanded="false"
                                            style="display: flex; align-items: center;">
                                            <span [class]="'fi ' + selectedAreaCode.cou_flag"
                                                style="margin: 0 5px;"></span>
                                            <p style="margin: 0 !important;"> (+{{ selectedAreaCode.cou_phone_code }})
                                            </p>
                                            <mat-icon>expand_more</mat-icon>
                                        </button>
                                        <div class="dropdown-menu" [ngClass]="{'show': dropdownOpen}"
                                            (clickOutside)="closeDropdown()">
                                            <button class="dropdown-item" *ngFor="let areaCode of areaCodes"
                                                (click)="selectAreaCode(areaCode); $event.preventDefault()">
                                                <span [class]="'fi ' + areaCode.cou_flag"></span> (+{{
                                                areaCode.cou_phone_code }})
                                            </button>
                                        </div>

                                    </div>
                                    <input class="form-control" type="tel" formControlName="telefono" id="telefono"
                                        placeholder="Teléfono">
                                </div>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('telefono')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa entre {{selectedAreaCode?.cou_min_phone}} y
                                    {{selectedAreaCode?.cou_max_phone}} dígitos
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="pais"></label>
                                <select class="form-control" id="pais" formControlName="pais">
                                    <option value="" disabled selected>Selecciona tu País</option>
                                    <option *ngFor="let pais of paises" [value]="pais.cou_id">{{ pais.cou_name }}
                                </select>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('pais')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Selecciona un País.
                                </p>

                            </div>
                            <div class="form-group">
                                <label for="region"></label>
                                <select class="form-control" id="region" formControlName="region">
                                    <option value="" disabled selected>Selecciona tu región</option>
                                    <option *ngFor="let region of regiones" [value]="region.reg_id">{{
                                        region.reg_name}}
                                    </option>
                                </select>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('region')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Selecciona un Región.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="comuna"></label>
                                <select class="form-control" id="comuna" formControlName="comuna">
                                    <option value="" disabled selected>Selecciona tu comuna</option>
                                    <option *ngFor="let comuna of comunas" [value]="comuna.com_id">{{
                                        comuna.com_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('comuna')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Selecciona una comuna.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="direccion"></label>
                                <input class="form-control" type="text" id="direccion" formControlName="direccion"
                                    placeholder="Ingresa tu dirección">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('direccion')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa una dirección.
                                </p>
                            </div>

                            <div class="form-group">
                                <label for="numero"></label>
                                <input class="form-control" type="number" id="numero" formControlName="numero"
                                    placeholder="Ingresa tu numeración">
                            </div>
                            <div class="error-message">
                                <p *ngIf="campoNoValido('numero')" class="text-danger mb-0 pb-0 mt-1"
                                    style="display: flex; align-items: center;">
                                    <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                    Ingresa una numeración válida.
                                </p>
                            </div>


                            <div class="form-group">
                                <label for="rest"></label>
                                <input class="form-control" type="text" id="rest" formControlName="rest"
                                placeholder="Departamento / Oficina">
                            </div>
                            <!-- <p *ngIf="campoNoValido('rest')" class="text-danger mb-0 pb-0 mt-1" style="display: flex; align-items: center;">
                                        <mat-icon style="font-size: 15px;">cancel</mat-icon>
                                        Ingresa una numeración.
                                    </p> -->



                        </div>

                    </div>
                </form>
            </div>
        </div>

        

        <div *ngIf="pagina === 1">
            <div class="container-fluid">
                <form [formGroup]="cambiaPass" (ngSubmit)="cambiaPassword()">
                    <!-- Título -->
                    <!-- <div class="row">
                        <div class="col-12 text-center">
                            <p class="letra-tit my-4">{{titulo[pagina]}}</p>
                        </div>
                    </div> -->

                    <!-- Campos de Contraseña -->
                    <div class="row justify-content-center cambia-pass px-lg-5 px-md-3 px-2">
                        <div class="col-12 col-md-8 col-lg-6">

                            <!-- Contraseña Actual -->
                            <div class="form-group row signup-input-wrapper signup-input-wrapper-addon"
                                [ngClass]="{'signup-input-wrapper-addon-blue': signupPass, 'signup-input-wrapper-addon-gray': !signupPass}">
                                <div class="col-10 col-md-11 m-0 signup-custom-input">
                                    <div class="input-group m-0 p-0">
                                        <input class="form-control" [type]="fieldTextType1 ? 'text' : 'password'"
                                            formControlName="contrasena_actual" id="contrasena_actual"
                                            name="contrasena_actual" placeholder="Contraseña actual"
                                            onfocus="this.placeholder = '';"
                                            onblur="this.placeholder = 'Contraseña actual';" (focus)="signupPass=true;"
                                            (blur)="signupPass=false;" (input)="checkPass1()">
                                    </div>
                                </div>
                                <div class="col-2 col-md-1 m-0 m-0 align-self-center"
                                    style="display: flex; justify-content: center;">
                                    <span class="calendar" (click)="toggleFieldTextType1()">
                                        <mat-icon>{{ fieldTextType1 ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </span>
                                </div>
                            </div>

                            <br>

                            <!-- Nueva Contraseña -->
                            <div class="form-group row signup-input-wrapper signup-input-wrapper-addon"
                                [ngClass]="{'signup-input-wrapper-addon-blue': signupPass1Focus, 'signup-input-wrapper-addon-gray': !signupPass1Focus}">
                                <div class="col-10 col-md-11 m-0 signup-custom-input">
                                    <div class="input-group m-0 p-0">
                                        <input class="form-control" [type]="fieldTextType2 ? 'text' : 'password'"
                                            formControlName="contrasena_nueva" id="contrasena_nueva"
                                            name="contrasena_nueva" placeholder="Contraseña nueva*"
                                            onfocus="this.placeholder = '';"
                                            onblur="this.placeholder = 'Contraseña nueva*';"
                                            (focus)="signupPass1Focus=true;" (blur)="signupPass1Focus=false;"
                                            (input)="checkPass1()">
                                    </div>
                                </div>
                                <div class="col-2 col-md-1 m-0 m-0 align-self-center"
                                    style="display: flex; justify-content: center;">
                                    <span class="calendar" (click)="toggleFieldTextType2()">
                                        <mat-icon>{{ fieldTextType2 ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </span>
                                </div>
                            </div>

                            <br>

                            <!-- Requisitos de Contraseña -->
                            <div class="password-desc">
                                <p class="{{ passMinLength ? 'ok' : 'nok' }}"
                                    style="display: flex; align-items: center;">
                                    <mat-icon>{{ passMinLength ? 'check_circle' : 'cancel' }}</mat-icon> Debe contener
                                    al menos 8 caracteres
                                </p>
                                <p class="{{ passCapital ? 'ok' : 'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon>{{ passCapital ? 'check_circle' : 'cancel' }}</mat-icon> Debe contener al
                                    menos 1 mayúscula
                                </p>
                                <p class="{{ passLetter ? 'ok' : 'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon>{{ passLetter ? 'check_circle' : 'cancel' }}</mat-icon> Debe contener al
                                    menos 1 minúscula
                                </p>
                                <p class="{{ passNumber ? 'ok' : 'nok' }}" style="display: flex; align-items: center;">
                                    <mat-icon>{{ passNumber ? 'check_circle' : 'cancel' }}</mat-icon> Debe contener al
                                    menos 1 número
                                </p>
                            </div>
                            <br>
                            <div class="form-group row signup-input-wrapper signup-input-wrapper-addon"
                                [ngClass]="{'signup-input-wrapper-addon-blue': signupPass1Focus, 'signup-input-wrapper-addon-gray': !signupPass1Focus}">
                                <div class="col-10 col-md-11 m-0 signup-custom-input">
                                    <div class="input-group m-0 p-0">
                                        <input class="form-control" [type]="fieldTextType3 ? 'text' : 'password'"
                                            formControlName="contrasena_nueva_2" id="contrasena_nueva_2"
                                            name="contrasena_nueva" placeholder="Repetir contraseña nueva*"
                                            onfocus="this.placeholder = '';"
                                            onblur="this.placeholder = 'Repetir contraseña nueva*';"
                                            (focus)="signupPass2Focus=true;" (blur)="signupPass2Focus=false;"
                                            (input)="checkPass1()">
                                    </div>
                                </div>
                                <div class="col-2 col-md-1 m-0 m-0 align-self-center"
                                    style="display: flex; justify-content: center;">
                                    <span class="calendar" (click)="toggleFieldTextType3()">
                                        <mat-icon>{{ fieldTextType3 ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
    <footer class="footer">
        <div>
            <!-- Círculos para las nuevas páginas -->
            <mat-icon *ngIf="pagina == 0" class="boton-circulo" [ngStyle]="{color: estilo[0]}">circle</mat-icon>
            <mat-icon *ngIf="pagina == 1" class="boton-circulo" [ngStyle]="{color: estilo[1]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[2]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[3]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[4]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[5]}">circle</mat-icon>
            <mat-icon class="boton-circulo" [ngStyle]="{color: estilo[6]}">circle</mat-icon>
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <div *ngIf="pagina<6" style="width: 100%;height: 60px;align-items: center;text-align: center; display: flex; justify-content: center;">
                <button *ngIf="pagina < 2" (click)="salirBoton()" class="boton-omitir">Salir</button>
                <button *ngIf="pagina > 2" (click)="volverBoton()" class="boton-omitir">Volver</button>
                <button *ngIf="pagina == 2" (click)="omitirBoton()" class="boton-omitir">Omitir</button>
                <button *ngIf="pagina >= 2" (click)="siguienteBoton()" class="boton-siguiente">Siguiente</button>
                <button 
                *ngIf="pagina == 0" 
                    class="boton-siguiente" 
                    [ngClass]="{'boton-siguiente-disabled': registerForm.invalid}" 
                    [disabled]="registerForm.invalid" 
                    (click)="siguienteBoton()" 
                    style="float: right;">
                    Siguiente
                </button>
                <button 
                *ngIf="pagina == 1" 
                    class="boton-siguiente" 
                    [ngClass]="{'boton-siguiente-disabled': cambiaPass.invalid}" 
                    [disabled]="cambiaPass.invalid" 
                    (click)="siguienteBoton()" 
                    style="float: right;">
                    Siguiente
                </button>
            </div>
            <div *ngIf="pagina>5" style="width: 100%;height: 60px;align-items: center;text-align: center;">
                <button (click)="empezemosBoton()" class="boton-siguiente" style="width: 40%">¡Empecemos!</button>
            </div>
        </div>

    

    </footer>

</div>